import { Box, Typography } from '@mui/material';

import {
  ClinicPayerConnectionsView,
  type ClinicPayerConnectionsViewProps,
} from './ClinicPayerConnectionsView';

type AdminPayerConnectionsViewProps = Omit<
  ClinicPayerConnectionsViewProps,
  'onStediLinkClick' | 'audience'
>;

const noop = () => undefined;

/** Clinic presentation for staff. */
export function AdminPayerConnectionsView(props: AdminPayerConnectionsViewProps) {
  return (
    <Box
      component="section"
      aria-label="Payer connections"
      sx={{ p: { xs: 2, md: 3 }, bgcolor: 'background.paper' }}
    >
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Payer connections
      </Typography>
      <ClinicPayerConnectionsView
        {...props}
        audience="staff"
        onStediLinkClick={noop}
      />
    </Box>
  );
}
